export const defaultImage = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7TXmhFuQVo9V9mlF_7ze_8iQ64BLdtqIzkQ&s'

export const colors = ['#f542f5', '#2381fc', "#6a3d9a", "#ff7f00", "#e31a1c", "#33a02c", '#13eddb', "#1f78b4", "#b2df8a", "#fb9a99", "#fdbf6f", "#b15928"]
